import React, { Component } from 'react';
import Modal from '../_utils/modal';
import PropTypes from 'prop-types';

class ConfirmationDialog extends Component {
  constructor(props) {
    super(props);
  }

  handleClose = () => {
    const { onClose } = this.props;

    onClose();
  }

  handleConfirm = () => {
    const { onConfirm } = this.props;

    onConfirm();
  }

  render() {
    return (
      <Modal className="confirmation-dialog"
        open={ this.props.shouldShowDialog }
        maxWidth={486}
        title={ this.props.title }
        actions={
          <div>
            <button className="btn btn-link" onClick={ this.handleClose } aria-label="Cancel">Cancel</button>
            <button className='btn btn-primary float-right proceed-anyway'
                    aria-label={ this.props.confirmationText || 'Proceed anyway' }
                    onClick={this.handleConfirm}>
              { this.props.confirmationText || 'Proceed anyway' }
            </button>
          </div>
        }
        onClose={ this.handleClose } >
        { this.props.dialogText }
      </Modal>
    )
  };
}

ConfirmationDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  dialogText: PropTypes.string.isRequired,
  confirmationText: PropTypes.string,
  shouldShowDialog: PropTypes.bool.isRequired
};

export default ConfirmationDialog
